<template>
  <FormSubmitPopup
  :title="title"
  v-model="isShow"
  @popupClose="closePopup"
  hideRgtBtn
  large
  >
  <template v-slot:input>
    <v-container style="min-height:600px" ref="helpManualMain" lazy-validation>
      <h1>{{$t('loadingAuthHelp')}}</h1>
    </v-container>
  </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup.vue'

export default{
  name: 'HelpManualPopup',
  components: {
    FormSubmitPopup
  },
  mounted () {
    this.getHelpManualData()
  },
  methods: {
    closePopup () {
      this.$emit('input', false)
    },
    async getHelpManualData () {
      await this.$store.dispatch('getHelpManualData', this.helpManualFileUrl)
        .then((res) => {
          this.$nextTick(() => {
            this.$refs.helpManualMain.innerHTML = res
          })
        })
        .catch((error) => {
          this.$store.dispatch('showToast', {info: error, level: 'error'})
          this.closePopup()
        })
    }
  },
  props: {
    isShow: Boolean,
    title: String,
    helpManualFileUrl: String
  }
}
</script>

<style>
img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/HelpManualPopup.vue